import config from 'config';
import axios from 'axios';
import LoadingApi from './loading-api';
import matchProtocol from '../utils/matchProtocol'


let instance = axios.create({
  baseURL: config.core.API.endpoint,
  timeout: config.core.API.timeout
});

const debugRequest = config.core.API.debug.request;
const debugResponse = config.core.API.debug.response;

instance.interceptors.request.use(
  call => {
		LoadingApi.showLoading();
    if (debugRequest) console.log("requested", call);
    return call;
  }, error => {
    if (debugRequest) console.log("not requested", error);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  response => {
		LoadingApi.hideLoading();
    if (debugResponse) console.log("success", response);
    return (response.data !== undefined) ? response.data : response;
  }, error => {
		LoadingApi.hideLoading();
    if (debugResponse) console.log("error", error);
    return Promise.reject(error);
  }
);

export default instance;


// WEBPACK FOOTER //
// ./src/api/dbInstace.js